module.exports = __webpack_public_path__ + "static/media/lyft.24640804.svg";